import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

/*================== Bootstrap 5 & Bootstrap 5 Icons =================*/
import "./assets/bootstrap.min.css";

createApp(App).use(store).use(router).mount("#app");
